<template>
    <b-list-group style="font-size: 0.9rem" >
        <b-list-group-item class="px-2 py-1">
            <i
                class="fas fa-square complete"
                :title="$t('patient.complete')"
            />
            {{ completeLegendHelper }}
        </b-list-group-item>
        <b-list-group-item class="px-2 py-1">
            <i
                class="fas fa-square incomplete"
                :title="$t('patient.incomplete')"
            />
            {{ incompleteLegendHelper }}
        </b-list-group-item>
    </b-list-group>
</template>

<script>
    export default {
        name: 'BaseLegend',
        props: {
            completeLegendHelper: {
                type: String,
                required: true,
            },
            incompleteLegendHelper: {
                type: String,
                required: true,
            },
        },
    };
</script>
